App.prototype.appendModal = function(id, className) {
	
	var modal = $('#'+id);
	
	if (id && modal.length) {
		return modal;
	}
	
	modal = $(this.get('theme.modal_template'));
	
	modal.attr('id', id);
	
	if (className) {
		modal.addClass(className);
	}
	
	modal.find('.modal-content').html(this.get('theme.loader_template'));
	
	$('body').append(modal);
	
	return modal;
}

App.prototype.showModal = function(id) {
    
	if (!id || id == '#' || id.indexOf('=') > -1) {
		return;
	}
	
	var modal = $(id + '.modal');
	
	if (modal.length) {
		modal.modal('show');
	}
}

App.addModule(function(app) {

    app.on('loaded', () => {
        
        // hash open
	    app.showModal(location.hash)
        
        // content loader
	    var template = app.get('theme.loader_template')
	    
	    $(document).on('shown.bs.modal', '.modal', function() {
		    
		    var modal = $(this);
		    
		    var url = modal.data('remote-url');
		    
		    if (url && (modal.data('') || !modal.data('mia.loaded'))) {
			    
			    var $loader = $(template);
			    var $iframe = modal.find('iframe');
			    
			    if ($iframe.length) {
				    
				    $loader.insertBefore($iframe);
				    $loader.show();
				    
				    $iframe.attr('src',url);
				    
				    $iframe.on('load', function() {
					    $loader.hide();
				    });
			    }
			    else {
				    
				    modal.find('.modal-content').html($loader);
				    
        			$loader.show();
				    
				    modal.find('.modal-content').load(url);
			    }
			    
			    modal.data('mia.loaded', true);
		    }
	    });
        
        $(document).on('shown.bs.modal', function(event) {
            $(event.target).find('input[autofocus]').focus()
        })
        
        // close on esc
	    $(document).on('keyup', function(e) {
		    if (e.keyCode == 27) {
			    var modal = $('.modal.in')
                if (modal.find('.close').length) {
                    modal.modal('hide');
                }
		    }
	    });
    })
})
